<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="原有达人值" prop="sageValue">
        <a-input-number v-model="form.sageValue" placeholder="无法修改" style="width: 100%" :disabled="true"/>
      </a-form-model-item>
      <a-form-model-item label="原有虚拟达人值" prop="sageValueVirtual">
        <a-input-number v-model="form.sageValueVirtual" placeholder="无法修改" style="width: 100%" :disabled="true"/>
      </a-form-model-item>
      <a-form-model-item label="调整虚拟达人值（正数增加，负数减少）" prop="sageValueVirtualSet" >
        <a-input-number v-model="form.sageValueVirtualSet" placeholder="请输入要调整的虚拟达人值（会添加到达人值和每月达人值）" style="width: 100%"/>
      </a-form-model-item>
      <a-form-model-item label="测评活动测本数量（徽章用）">
        <a-input-number v-model="form.evaluatorAmount" :min="0" :max="9999" :precision="0" style="width: 90%" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getUserExtra, addUserExtra, updateUserExtra } from '@/api/user/userExtra'
import { mapGetters } from 'vuex'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      previewVisible: false,
      previewImage: '',
      // 表单参数
      form: {
        id: null,
        sageValue: null,
        sageValueVirtual: null,
        sageValueVirtualSet: 0,
        evaluatorAmount: 0
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        sageValue: null,
        sageValueVirtual: null,
        sageValueVirtualSet: 0,
        evaluatorAmount: 0
      }
    },

    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getUserExtra(id).then(response => {
        this.formTitle = '修改'
        if (response.data != null) {
          this.form = {
            id: response.data.id,
            sageValue: response.data.sageValue,
            sageValueVirtual: response.data.sageValueVirtual,
            sageValueVirtualSet: 0,
            evaluatorAmount: response.data.evaluatorAmount
          }
          this.open = true
        } else {
          this.$message.error('接收数据出错！')
        }
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateUserExtra(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addUserExtra(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style scoped>

</style>
